/**
 * Copy Planner feature flag.
 *
 * CopyPlanner is the default. Resolution order (first match wins):
 *   1. URL query: ?copyPlanner=1 / ?copyPlanner=0  (also persisted to localStorage)
 *   2. localStorage key `copy-planner-enabled` = '1' | '0'
 *   3. process.env.REACT_APP_LEGACY_COPY_DIALOG === '1'  → reverts to old dialog
 *   4. default: true (CopyPlanner)
 *
 * Toggle from devtools console:
 *   localStorage.setItem('copy-planner-enabled', '0'); location.reload();
 */
const STORAGE_KEY = 'copy-planner-enabled';

export function isCopyPlannerEnabled(): boolean {
  try {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      const q = params.get('copyPlanner');
      if (q === '1' || q === 'true') {
        window.localStorage.setItem(STORAGE_KEY, '1');
        return true;
      }
      if (q === '0' || q === 'false') {
        window.localStorage.setItem(STORAGE_KEY, '0');
        return false;
      }
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored === '1') return true;
      if (stored === '0') return false;
    }
  } catch {
    // ignore — fall through to env / default
  }
  return process.env.REACT_APP_LEGACY_COPY_DIALOG !== '1';
}
